import api from '../../server';

export default {
  namespaced: true,
  state: {
    assess: localStorage.assess !== undefined&&localStorage.assess !== "" ? JSON.parse(localStorage.assess) : {assessAmount:0}
  },
  actions:{
    fetchAssessData({commit}, {params}) {
      return api.Assess(params).then(data => commit('setAssessData', {data}))
    }
  },
  mutations: {
    setAssessData(state,data){
      state.assess = data.data.data
    },
  }
}
